

























































import BasicTs from '@/components/mixins/basicts.vue'
import moment from "moment-timezone";
import { Component, Vue, Mixins } from 'vue-property-decorator'
import * as types from '@/lib/definition/types'
moment.locale('ja')

@Component({
  mixins: [BasicTs]
})
export default class PrivacyWord extends Mixins(BasicTs) {
  private privacyWords = new Array<types.PrivacyWord>()
  private addingObj = new types.PrivacyWordConstructor()
  private dialogAdding = false
  private objectToDelete = new types.PrivacyWordConstructor()
  private dialogDeleting = false
  private requestParam: any = null

  async mounted() {
  }
  async masterReady () {
    if (!this.$store.getters['Login/isAdmin']) {
      // redirect to home when you are not admin
      this.$router.push(this.site.deployFolder + "/")
    }
    await this.search()
  }
  async search () {
    this.privacyWords = await this.$store.direct.dispatch.PrivacyWord.listAll()
  }
  prepareToAdd () {
    this.addingObj = new types.PrivacyWordConstructor()
    this.dialogAdding = true
  }
  prepareToDelete (item: types.PrivacyWord) {
    this.objectToDelete = item
    this.dialogDeleting = true
  }
  prepareToEdit (item: types.PrivacyWord) {
    this.addingObj = JSON.parse(JSON.stringify(item)) 
    this.dialogAdding = true
  }
  async confirmAdding () {
    this.dialogAdding = false
    this.requestParam = this.addingObj
    this.requestParam.isPersonal = false
    await this.$store.direct.dispatch.PrivacyWord.add(this.requestParam); 
    this.dispSuccess('メンバータグを追加しました。')
    this.search()
  }
  async confirmDeleting () {
    this.dialogAdding = false
    this.requestParam = this.addingObj
    this.requestParam.isPersonal = false
    // TODO add delete method
    await this.$store.direct.dispatch.PrivacyWord.add(this.requestParam); 
    this.dispSuccess('メンバータグを追加しました。')
    this.search()
  }
}
